var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"white","text":"","plain":""},on:{"click":function($event){return _vm.$emit('back')}}},[_c('v-icon',{staticClass:"primary white--text rounded-lg mr-3"},[_vm._v("$prev")]),_c('i18n',{staticClass:"primary--text mr-2 text-caption font-weight-bold text-none",attrs:{"tag":"span"},domProps:{"innerHTML":_vm._s(_vm.label)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }